// extracted by mini-css-extract-plugin
export default {"root":"CountDown_root__LDcw2"};